import React, { useState, useEffect } from 'react'
import { Box, Button, Grid2, Paper, Tab, Tabs, Typography, Stack, Chip, Tooltip } from '@mui/material'
import MiTabla from '../../../components/plantilla/tabla/MiTabla'
import { myApi } from '../../../config/axiosConfig'
import ModalAsignarTema from './modales/ModalAsignarTema'
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';

// Iconos
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import CategoryIcon from '@mui/icons-material/Category';
import FeedIcon from '@mui/icons-material/Feed';
import TopicIcon from '@mui/icons-material/Topic';
import BuildIcon from '@mui/icons-material/Build';
import ModalAgregarPregunta from './modales/ModalAgregarPregunta'
import ModalAgregarTemas from './modales/ModalAgregarTemas'
import ModalAgregarTipoFormulario from './modales/ModalAgregarTipoFormulario'
import Swal from 'sweetalert2'
import DashboardPuntosInspeccion from '../components/DashboardPuntosInspeccion'

function Formularios() {
    //USE STATE DE DATOS PARA LA TABLA
    const [dataTemas, setDataTemas] = useState([])
    const [dataFormularios, setDataFormularios] = useState([])
    const [dataTiposDeFormularios, setDataTiposDeFormularios] = useState([])
    const [dataPuntosInspeccion, setDataPuntosInspeccion] = useState([])

    //USE STATE QUE SE UTILIZA PARA ABRIR EL MODAL DE ASIGNAR TEMA
    const [openModalAsignarTema, setOpenModalAsignarTema] = useState(false)

    // USE STATE QUE SE UTILIZA PARA ABRIR EL MODAL DE AGREGAR PREGUNTA
    const [openModalAgregarPregunta, setOpenModalAgregarPregunta] = useState(false)

    // USE STATE QUE SE UTILIZA PARA ABRIR EL MODAL DE AGREGAR TEMAS
    const [openModalAgregarTemas, setOpenModalAgregarTemas] = useState(false)

    // USE STATE QUE SE UTILIZA PARA ABRIR EL MODAL DE AGREGAR TIPO DE FORMULARIO
    const [openModalAgregarTipoFormulario, setOpenModalAgregarTipoFormulario] = useState(false)

    //USE STATE PARA EL FORMULARIO ACTUAL
    const [selectedFormulario, setSelectedFormulario] = useState(null);

    //USE STATE PARA EL TEMA ACTUAL
    const [selectedTema, setSelectedTema] = useState(null);

    //USE STATE PARA EL TIPO DE FORMULARIO ACTUAL
    const [selectedTipoFormulario, setSelectedTipoFormulario] = useState(null);

    //USE STATE PARA SABER SI SE ESTA EDITANDO O CREANDO
    const [isEditing, setIsEditing] = useState(false);

    /*=============================================
    = FUNCION PARA OBTENER DATOS DEL API
    =============================================*/
    const fetchTemas = async () => {
        try {
            const response = await myApi.get('/inspeccion/temas/getTemas')
            setDataTemas(response.data.data)
        } catch (error) {
            console.error('Error fetching data:', error)
        }
    }

    /*=============================================
    FUNCION QUE OBTIENE LOS FORMULARIOS
    =============================================*/
    const fetchFormularios = async () => {
        try {
            const response = await myApi.get('/inspeccion/formularios/getFormularios')
            setDataFormularios(response.data.data)
        } catch (error) {
            console.error('Error fetching data:', error)
        }
    }

    /*=============================================
    FUNCION QUE OBTIENE LOS TIPOS DE FORMULARIOS
    =============================================*/
    const fetchTiposDeFormularios = async () => {
        try {
            const response = await myApi.get('/inspeccion/tiposDeFormularios/getTiposDeFormularios')

            if(response.data.success){
                setDataTiposDeFormularios(response.data.data)
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un error al buscar los tipos de formularios.' + response.data.message 
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error)
        }
    }

    /*=============================================
    FUNCION QUE OBTIENE LOS PUNTOS DE INSPECCION
    =============================================*/
    const fetchPuntosInspeccion = async () => {
        try {
            const response = await myApi.get('/inspeccion/preguntas/getPreguntasPorFormulario')
            setDataPuntosInspeccion(response.data.data)
        } catch (error) {
            console.error('Error fetching data:', error)
        }
    }

    /*=============================================
    = FUNCION QUE RENDERA EL MODAL DE ASIGNAR TEMA=
    =============================================*/
    const renderModalAsignarTema = () => {
        setOpenModalAsignarTema(true)
        setSelectedFormulario(null);
        setIsEditing(false);
    }

    /*=============================================
    FUNCION QUE CIERRA EL MODAL DE ASIGNAR TEMA
    =============================================*/
    const handleCloseModal = () => setOpenModalAsignarTema(false);

    /*=============================================
    FUNCION QUE RENDERIZA EL MODAL DE AGREGAR PREGUNTA
    =============================================*/
    const renderModalAgregarPregunta = () => {
        setOpenModalAgregarPregunta(true)
        setSelectedFormulario(null);
        setIsEditing(false);
    }

    /*=============================================
    FUNCION QUE CIERRA EL MODAL DE AGREGAR PREGUNTA
    =============================================*/
    const handleCloseModalPreguntas = () => setOpenModalAgregarPregunta(false);

    /*=============================================
    FUNCION QUE RENDERIZA EL MODAL DE AGREGAR TEMAS
    =============================================*/
    const renderModalAgregarTemas = () => {
        setOpenModalAgregarTemas(true)
        setSelectedTema(null);
        setIsEditing(false);
    }

    /*=============================================
    FUNCION QUE CIERRA EL MODAL DE AGREGAR TEMAS
    =============================================*/
    const handleCloseModalTemas = () => setOpenModalAgregarTemas(false);

    /*=============================================
    = USE STATE PARA LAS TABS                      =
    =============================================*/
    const [TabValue, SetTabValue] = useState("temas");

    /*=============================================
    = FUNCION PARA CAMBIAR DE TAB                 =
    =============================================*/
    const handleChangeTab = (event, newValue) => {
        SetTabValue(newValue);
    };

    /*=============================================
    =            COLUMNAS DE LA TABLA DE TEMAS     =
    =============================================*/
    const columns = [
        {
            field: 'nombre_tema', headerName: 'Tema', flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'descripcion_tema', headerName: 'Descripción', flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 100,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEditarTemas(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleEliminarTemas(params.row)}
                />
            ],
        }

    ];

    /*=============================================
    FUNCION QUE MANEJA LA EDICIÓN DE TEMAS
    =============================================*/
    const handleEditarTemas = (tema) => {
        setSelectedTema(tema);
        setIsEditing(true);
        setOpenModalAgregarTemas(true);
    };

    /*=============================================
    FUNCION QUE ELIMINA TEMAS
    =============================================*/
    const handleEliminarTemas = async (tema) => {
        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await myApi.delete(`/inspeccion/temas/deleteTema/${tema.id_tema}/${tema.tipo_tema}`,);

                    if (response.data.success) {
                        Swal.fire({ icon: 'success', title: 'Tema eliminado' });
                        await fetchTemas();
                    } else {
                        console.error("Error al eliminar tema");
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        });
        
    };

    /*=============================================
    =            COLUMNAS DE LA TABLA DE FORMULARIOS     =
    =============================================*/
    const columnsFormularios = [
        {
            field: 'nombre_formulario', headerName: 'Formulario', flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'descripcion', headerName: 'Descripción', flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'temas', headerName: 'Temas', flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                if (!params.row.temas) return null; // Evita errores si es undefined o null

                let json;
                try {
                    json = JSON.parse(params.row.temas);
                } catch (e) {
                    console.error("Error parsing JSON", e);
                    return <Typography color="error">Error al cargar temas</Typography>;
                }

                return (
                    <Tooltip title={json.map(t => t.nombre_tema).join(', ')}>
                        <Typography variant="body2" noWrap>
                            {json.slice(0, 2).map(t => t.nombre_tema).join(', ')}
                            {json.length > 2 ? '…' : ''}
                        </Typography>
                    </Tooltip>
                  );
            }
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 100,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEditarFormulario(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleEliminarFormulario(params.row)}
                />
            ],
        }
    ];

    /*=============================================
    FUNCION QUE MANEJA LA EDICIÓN DE FORMULARIOS
    =============================================*/
    const handleEditarFormulario = (formulario) => {
        setSelectedFormulario(formulario);
        setIsEditing(true);
        setOpenModalAsignarTema(true);
    };

    /*=============================================
    FUNCION QUE ELIMINA FORMULARIOS
    =============================================*/
    const handleEliminarFormulario = async (formulario) => {
        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de eliminar el formulario?',
            text: 'Esta acción no se puede deshacer',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await myApi.delete(`/inspeccion/formularios/deleteFormulario/${formulario.id_formulario}`);

                    if (response.data.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Formulario eliminado',
                        });
                        await fetchFormularios();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al eliminar formulario',
                        });
                    }
                } catch (e) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al eliminar formulario',
                    });
                }
            }
        });
    };

    /*=============================================
    =            COLUMNAS DE LA TABLA DE TIPOS DE FORMULARIOS     =
    =============================================*/
    const columnsTiposDeFormularios = [
        {
            field: 'nombre_TipoFormulario', headerName: 'Tipo de formulario', flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 100,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEditarTipoFormulario(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleEliminarTipoFormulario(params.row)}
                />
            ],
        }

    ];

    /*=============================================
    FUNCION QUE MANEJA LA EDICIÓN DE TIPOS DE FORMULARIOS
    =============================================*/
    const handleCloseModalTipoFormulario = () => setOpenModalAgregarTipoFormulario(false);

    /*=============================================
    FUNCION QUE MANEJA LA EDICIÓN DE TIPOS DE FORMULARIOS
    =============================================*/
    const handleEditarTipoFormulario = (tipoFormulario) => {
        setSelectedTipoFormulario(tipoFormulario);
        setIsEditing(true);
        setOpenModalAgregarTipoFormulario(true);
    };

    /*=============================================
    FUNCION QUE ELIMINA TIPOS DE FORMULARIOS
    =============================================*/
    const handleEliminarTipoFormulario = async (tipoFormulario) => {

        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de eliminar la categoria?',
            text: 'Esta acción no se puede deshacer',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await myApi.delete(`/inspeccion/tiposDeFormularios/deleteTiposDeFormularios/${tipoFormulario.id_tipoFormulario}`);

                    if (response.data.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Categoria eliminada',
                        });
                        await fetchTiposDeFormularios();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al eliminar la categoria',
                        });
                    }
                } catch (e) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al eliminar la categoria',
                    });
                }
            }
        });
    };

    /*=============================================
    FUNCION QUE RENDERIZA EL MODAL DE AGREGAR TIPO DE FORMULARIO
    =============================================*/
    const renderModalAgregarTipoFormulario = () => {
        setOpenModalAgregarTipoFormulario(true)
        setSelectedTipoFormulario(null);
        setIsEditing(false);
    }

    /*=============================================
    FUNCION QUE OBTIENE LOS DATOS DEL API
    =============================================*/
    useEffect(() => {
        fetchTemas()
        fetchFormularios()
        fetchTiposDeFormularios()
        fetchPuntosInspeccion()
    }, [])

    /*=============================================
    FUNCION QUE FILTRA LOS FORMULARIOS
    =============================================*/
    const formulariosFiltrados = dataFormularios.map(f => {
            const temasParseados = JSON.parse(f.temas || '[]');
            const temasValidos = temasParseados.filter(t => t.id_tema !== null && t.nombre_tema !== null);

            return {
                ...f,
                temas: temasValidos
            };
    }).filter(f => f.temas.length > 0);

    /*=============================================*/
    return (
        <Box>
            <Paper sx={{ padding: 2 }}>
                {/* Tabs */}
                <Tabs
                    value={TabValue}
                    onChange={handleChangeTab}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                >
                    <Tab value="temas" label="Catalogo de Temas" />
                    <Tab value="formularios" label="Formularios" />
                    <Tab value="tiposDeFormularios" label="Categorias de formularios" />
                    <Tab value="puntosInspeccion" label="Puntos de inspección" />
                </Tabs>

                {/* Contenido de las pestañas */}
                {TabValue === "temas" && (
                    <Box sx={{ marginTop: 2 }}>
                        <Grid2 container spacing={2} sx={{ marginBottom: 2 }}>
                            <Grid2 item xs={6}>
                                <Button variant="contained" color="primary" onClick={renderModalAgregarTemas} startIcon={<TopicIcon />}>
                                    Crear Tema
                                </Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 container>
                            <Grid2 item size={{ xs: 12, md: 12 }} sx={{ marginTop: 2 }}>
                                {/* Tabla de temas */}
                                <MiTabla columns={columns} data={dataTemas} getRowId={(row) => row.id_tema} />
                            </Grid2>
                        </Grid2>
                    </Box>
                )}

                {TabValue === "tiposDeFormularios" && (
                    <Box sx={{ marginTop: 2 }}>
                        <Grid2 container spacing={2} sx={{ marginBottom: 2 }}>
                            <Grid2 item size={{ xs: 6, md: 6 }} sx={{ display: 'flex', justifyContent: 'start', marginRight: 'auto' }}>
                                <Button variant="contained" color="primary" onClick={renderModalAgregarTipoFormulario} startIcon={<CategoryIcon />}>
                                    Crear categoria
                                </Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 container>
                            <Grid2 item size={{ xs: 12, md: 12 }} sx={{ marginTop: 2 }}>
                                {/* Tabla de temas */}
                                <MiTabla columns={columnsTiposDeFormularios} data={dataTiposDeFormularios} getRowId={(row) => row.id_tipoFormulario } />
                            </Grid2>
                        </Grid2>
                    </Box>
                )}

                {TabValue === "formularios" && (
                    <Box sx={{ marginTop: 2 }}>
                        <Grid2 container spacing={2} sx={{ marginBottom: 2 }}>
                            <Grid2 item size={{ xs: 6, md: 6 }} sx={{ display: 'flex', justifyContent: 'flex-start', marginRight: 'auto' }}>
                                <Button variant="contained" color="primary" onClick={renderModalAsignarTema} startIcon={<FeedIcon />}>
                                    Configurar Formulario
                                </Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 container>
                            <Grid2 item size={{ xs: 12, md: 12 }} sx={{ marginTop: 2 }}>
                                {/* Tabla de temas */}
                                <MiTabla columns={columnsFormularios} data={dataFormularios} getRowId={(row) => row.id_formulario} />
                            </Grid2>
                        </Grid2>
                    </Box>
                )}

                {TabValue === "puntosInspeccion" && (
                    <Box sx={{ marginTop: 2 }}>
                        <Grid2 container spacing={2} sx={{ marginBottom: 2 }}>
                            <Grid2 item xs={6}>
                                <Button variant="contained" color="primary" onClick={renderModalAgregarPregunta} startIcon={<BuildIcon />}>
                                    Diseñar Puntos de inspección
                                </Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 container>
                            <Grid2 item size={{ xs: 12, md: 12 }} sx={{ marginTop: 2 }}>
                                {/* Tabla de temas */}
                                <DashboardPuntosInspeccion  puntosInspeccion={dataPuntosInspeccion} refresh={fetchPuntosInspeccion} />
                            </Grid2>
                        </Grid2>
                    </Box>
                )}
                {dataTemas.length > 0 && <ModalAsignarTema open={openModalAsignarTema} onClose={handleCloseModal} temas={dataTemas} isEditing={isEditing} selectedFormulario={selectedFormulario} refresh={fetchFormularios} catTipoFormularios={dataTiposDeFormularios} />}

                <ModalAgregarPregunta open={openModalAgregarPregunta} onClose={handleCloseModalPreguntas} temas={dataTemas} isEditing={isEditing} selectedFormulario={selectedFormulario} formularios={formulariosFiltrados} refresh={fetchPuntosInspeccion} />

                <ModalAgregarTemas open={openModalAgregarTemas} onClose={handleCloseModalTemas} isEditing={isEditing} selectedTema={selectedTema} refresh={fetchTemas}/>

                <ModalAgregarTipoFormulario open={openModalAgregarTipoFormulario} onClose={handleCloseModalTipoFormulario} isEditing={isEditing} selectedTipoFormulario={selectedTipoFormulario} refresh={fetchTiposDeFormularios}/>

            </Paper>
        </Box>
    )
}

export default Formularios